import { render, staticRenderFns } from "./CalendarAsideRoomStatusTest.vue?vue&type=template&id=3826d150&scoped=true&"
import script from "./CalendarAsideRoomStatusTest.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideRoomStatusTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3826d150",
  null
  
)

export default component.exports